import React, { FC } from 'react';
import styled from 'styled-components';
import { IOrderSimulation } from '../../graphql/types';
import { Black, White, White2 } from '../../styles/colours';
import { DemiBold } from '../../styles/fonts';

const StyledProductCardContainer = styled.section`
  display: flex;
  flex-direction: column;
`;

const StyledProductCard = styled.div`
  border-radius: 4px;
  background: ${White2};
  color: ${Black};
  margin-left: 3.5rem;
`;

const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid ${White};
`;

const StyledHeading = styled.div`
  font-family: ${DemiBold};
  width: 10rem;
  padding: 1rem;
  border-right: 1px solid ${White};
`;

const StyledData = styled.div`
  padding: 1rem;
`;

export const ProductCard: FC<{
  orderSimulation: IOrderSimulation;
  quantity: string;
}> = ({ orderSimulation, quantity }) => {
  return (
    <StyledProductCardContainer>
      <StyledProductCard>
        <StyledRow>
          <StyledHeading>Product</StyledHeading>
          <StyledData data-type="product-description">
            {orderSimulation.product.description}
          </StyledData>
        </StyledRow>
        <StyledRow>
          <StyledHeading>Product ID</StyledHeading>
          <StyledData data-type="product-id">
            {orderSimulation.product.id}
          </StyledData>
        </StyledRow>
        <StyledRow>
          <StyledHeading>Quantity</StyledHeading>
          <StyledData data-type="product-quantity">{quantity}</StyledData>
        </StyledRow>
        <StyledRow>
          <StyledHeading>Unit of Measure</StyledHeading>
          <StyledData data-type="product-uom">
            {orderSimulation.product.unitOfMeasure}
          </StyledData>
        </StyledRow>
      </StyledProductCard>
    </StyledProductCardContainer>
  );
};
